import * as React from 'react';
import { Range } from 'slate';

interface BalloonToolbarOnExpandedContextValue {
  reSelectText: (selectionRange: Range) => void;
}

export const BalloonToolbarOnExpandedContext =
  React.createContext<BalloonToolbarOnExpandedContextValue>(null);


